import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import {
    AwaitIterators,
    GetAnimationClip,
    PlayAnimation,
} from '../AnimationHelper';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';

export class ShowPlusFive extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta: {
            showAdButton: boolean;
        }
    ): IterableIterator<number> {
        const plusFiveGroup = gameObject.find(
            'bottom_container/plus_five_group'
        );
        //const plusFiveImage = gameObject.find('plus_five_image');
        const plusFiveContainer = plusFiveGroup.find('plus_five_container');
        const plusFiveButton = plusFiveGroup.find(
            'plus_five_container/plus_five_button'
        );
        const plusFiveAdButton = plusFiveGroup.find(
            'plus_five_container/plus_five_ad_button'
        );

        const plusFiveGroupElement = plusFiveGroup.getComponent(
            ElementComponent
        );

        const plusFiveContainerElement = plusFiveContainer.getComponent(
            ElementComponent
        );
        const plusFiveButtonElement = plusFiveButton.getComponent(
            ElementComponent
        );
        const plusFiveAdButtonElement = plusFiveAdButton.getComponent(
            ElementComponent
        );

        // Only show ad-button if supported and only for first time using the booster per level.

        if (meta.showAdButton) {
            plusFiveAdButton.getComponent(Renderable).visible = true;
            /* prettier-ignore */ plusFiveButton.getComponent(ElementComponent).offsetTopLeft.y = -75;
            /* prettier-ignore */ plusFiveButton.getComponent(ElementComponent).offsetBottomRight.y = -75;
            plusFiveGroupElement.offsetTopLeft.y = 75;
            plusFiveGroupElement.offsetBottomRight.y = 75;
        } else {
            plusFiveAdButton.getComponent(Renderable).visible = false;
            plusFiveButton.getComponent(ElementComponent).offsetTopLeft.y = 0;
            plusFiveButton.getComponent(
                ElementComponent
            ).offsetBottomRight.y = 0;

            plusFiveGroupElement.offsetTopLeft.y = 0;
            plusFiveGroupElement.offsetBottomRight.y = 0;
        }

        const plusFiveContainerRenderable = plusFiveContainer.getComponent(
            Renderable
        );
        plusFiveContainerRenderable.visible = false;

        yield* PlayAnimation(GetAnimationClip('UIPopIn', plusFiveGroup));

        // Button slide down.
        plusFiveContainerRenderable.visible = true;

        plusFiveContainerElement.offsetTopLeft.set(0, -30);
        plusFiveContainerElement.offsetBottomRight.set(0, -30);
        const offsetTween = this.getTween(plusFiveContainerElement);

        plusFiveContainerRenderable.alpha = 0;
        const alphaTween = this.getTween(plusFiveContainerRenderable);

        offsetTween
            .to({ offsetX1: 0, offsetY1: -65, offsetX2: 0, offsetY2: -65 }, 150)
            .easing(Easing.Quadratic.Out);
        alphaTween.to({ alpha: 1 }, 50);

        yield* AwaitIterators([
            this.startTween(offsetTween),
            this.startTween(alphaTween),
        ]);
    }
}
